export default __webpack_public_path__ + "static/media/young-mountain.c50b30b7.jpg";